import { ReactNode } from 'react'

export const SectionCus = ({ children }: { children: ReactNode }) => {
  return <div className="container mx-auto relative">{children}</div>
}
